module.exports = __webpack_public_path__ + "static/media/A3B1BB12-DC16-4FB6-82EA-4878063CF239_Small.dc8e30c1.jpg";